export default __webpack_public_path__ + "static/media/singer.fe0c3b04.png";